import { render, staticRenderFns } from "./ServiceTypeSelector.vue?vue&type=template&id=1766b94d&"
import script from "./ServiceTypeSelector.vue?vue&type=script&lang=js&"
export * from "./ServiceTypeSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports